import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
// import { USER_REQUEST } from '../actions/user'
import {HTTP} from '@/main.js'
import * as firebase from "firebase/app"
// Add the Firebase services that you want to use
import "firebase/auth"
import "firebase/firestore"
import "firebase/messaging"

const state = {
  token: localStorage.getItem('user-token') || '',
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getToken: state => state.token
}

const firebaseConfig = {
  apiKey: "AIzaSyCo3THC72Ia-syNmUq2fgXSDIYeA6auRPo",
  authDomain: "intrare-escuelas.firebaseapp.com",
  databaseURL: "https://intrare-escuelas.firebaseio.com",
  projectId: "intrare-escuelas",
  storageBucket: "intrare-escuelas.appspot.com",
  messagingSenderId: "110756308723",
  appId: "1:110756308723:web:a6fab278d15b82c9d0f986",
  measurementId: "G-913X0X4YJ2"
}

firebase.initializeApp(firebaseConfig)

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      HTTP.post('api/auth/login/', user, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': user.language
        }
      })
      .then(function (res) {
        localStorage.setItem('user-token', res.data.token)
        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        if (firebase.messaging.isSupported()) {
          const messaging = firebase.messaging()
          messaging.getToken().then((currentToken) => {
            if (currentToken) {
              console.log('Token Actual: ')
              console.log(currentToken)
              console.log('Registrando Dispositivo...')
              HTTP.post('devices/', {
                registration_id: currentToken,
                type: 'web'
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + res.data.token
                }
              })
                .then(ok => {
                  console.log(ok)
                  console.log('Token Registrado Correctamente en la API')
                })
                .catch(error => {
                  console.log(error)
                  console.log('Error al Registrar Token en API')
                })
            } else {
              // Show permission request.
              console.log('No Instance ID token available. Request permission to generate one.');
              // Show permission UI.
            }
          }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err)
          })
        } else {
          console.log('Push Notifications Not Supported')
        }
        commit(AUTH_SUCCESS, res.data.token)
        // dispatch(USER_REQUEST)
        resolve(res)
      })
      .catch(function (err) {
        commit(AUTH_ERROR, err)
        localStorage.removeItem('user-token')
        reject(err)
      })
    })
  },

  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      HTTP.post('api/auth/logout/', {}, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + localStorage.getItem('user-token')
        }
      })
        .then(function () {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          resolve()
        })
        .catch(function (err) {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
